import React from 'react';
import {View, Text, TextInput, TouchableOpacity} from 'react-native';
import styles from '../../style/scanpack';
import globalStyles from '../../style/global';
import i18n from 'i18n-js';

export default function ShipmentRecord(props) {
  let Ship = props.Shipment;
  return (
    <View style={styles.shipContainer}>
      {props.errorMessageShow === false ? (
        <View>
          {Ship && Ship.se_all_shipments && (
            <View>
              <Text style={styles.shipParagraph}>
                {i18n.t("shipmentRecord.additionalShipments")}
              </Text>
              {Ship.se_all_shipments &&
                Ship.se_all_shipments.shipments.length > 0 &&
                Ship.se_all_shipments.shipments.map((order, index) => {
                  return (
                    <View key={index}>
                      <View style={styles.shipOrderTextContainer}>
                        <TouchableOpacity
                          testID='onPressButton'
                          onPress={() => props.callOrder(order)}
                        >
                          <Text style={styles.shipOrderLink}>
                            {order.increment_id}
                          </Text>
                        </TouchableOpacity>
                        <Text> Contains {order.items_count} items(s)</Text>
                      </View>
                    </View>
                  );
                })}
              <TouchableOpacity
                onPress={props.hideShipment}
                style={styles.shipCloseButton}
              >
                <Text style={styles.shipOrderTextContainer}>
                  {i18n.t("shipmentRecord.acknowledgeAndContinue")}
                </Text>
              </TouchableOpacity>
            </View>
          )}
          {Ship && Ship.se_old_combined_shipments && (
            <View>
              <Text style={styles.shipParagraph}>
                {i18n.t("shipmentRecord.shipmentWarning")}{' '}
              </Text>
              {Ship.se_old_combined_shipments &&
                Ship.se_old_combined_shipments.length > 0 &&
                Ship.se_old_combined_shipments.map((order, index) => {
                  return (
                    <View key={index}>
                      <View style={styles.shipOrderTextContainer}>
                        <TouchableOpacity
                          testID='onPressButton'
                          onPress={() => props.callOrder(order)}
                        >
                          <Text style={styles.shipOrderLink}>
                            {order.increment_id}
                          </Text>
                        </TouchableOpacity>
                        <Text> {order.status} </Text>
                      </View>
                    </View>
                  );
                })}
              <TouchableOpacity
                onPress={props.hideShipment}
                style={styles.shipCloseButton}
              >
                <Text style={styles.shipOrderTextContainer}>
                  {i18n.t("shipmentRecord.acknowledgeAndContinue")}
                </Text>
              </TouchableOpacity>
            </View>
          )}
          {Ship && Ship.se_old_split_shipments && (
            <View>
              <Text style={styles.shipParagraph}>
                {i18n.t("shipmentRecord.shipmentWarning")}{' '}
              </Text>
              {Ship.se_old_split_shipments &&
                Ship.se_old_split_shipments.length > 0 &&
                Ship.se_old_split_shipments.map((order, index) => {
                  return (
                    <View key={index}>
                      <View style={styles.shipOrderTextContainer}>
                        <TouchableOpacity
                         testID='onPressButton'
                          onPress={() => props.callOrder(order)}
                        >
                          <Text style={styles.shipOrderLink}>
                            {order.increment_id}
                          </Text>
                        </TouchableOpacity>
                        <Text>{order.status}</Text>
                      </View>
                    </View>
                  );
                })}
              <TouchableOpacity
                onPress={props.hideShipment}
                style={styles.shipCloseButton}
              >
                <Text style={styles.shipOrderTextContainer}>
                  {i18n.t("shipmentRecord.acknowledgeAndContinue")}
                </Text>
              </TouchableOpacity>
            </View>
          )}
        </View>
      ) : (
        <View>
          <Text style={styles.shipParagraph}>{props.errorMessage}</Text>
          <TouchableOpacity
            testID='hideShipment'
            onPress={props.hideShipment}
            style={styles.shipCloseButton}
          >
            <Text style={styles.shipOrderTextContainer}>Close</Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
}
